// Re-export shared themed primitives so existing consumers keep importing
// from "@/common/components/themed". The shared module is the source of
// truth; client portal historically defaulted ThemeToggleIcon to a 20px
// bulb, so we preserve that default while still allowing consumer overrides.

import React from "react";
import {
  ThemeToggleIcon as SharedThemeToggleIcon,
  type ThemeToggleProps,
} from "@wavvest/shared-layout";

export {
  Text,
  View,
  BackgroundView,
  BaseButton,
  PrimaryButton,
  CurrencyText,
  Link,
  HorizontalRule,
  ThemeToggle,
} from "@wavvest/shared-layout";
export type { ThemeToggleProps } from "@wavvest/shared-layout";

export const ThemeToggleIcon: React.FC<ThemeToggleProps> = ({ style }) => {
  return (
    <SharedThemeToggleIcon iconStyle={{ fontSize: "20px" }} style={style} />
  );
};
